import { useFormik } from 'formik';
import { Fragment } from 'react'
import { fetchDataFromApi } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import { CiCalendarDate } from 'react-icons/ci';
import { handleChangeDate } from '../../../../helpers/handleChange';
import SelectionBox from '../../../../constants/SelectionBox';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import { GenderOptions, MemberTypeOptions, MeterTypeOptions, ReaderOptions, TapSizeOptions, TapTypeOptions, ToleOptions } from '../../../../constants/Options';
import useFetchData from '../../../../helpers/useFetch';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { useSidebar } from '../../../../helpers/sidebarClose';
import { ACCOUNT_RPT_DATE } from '../../../../store/orgSlice';
import { useDispatch } from 'react-redux';

const MahasulRptFormView = ({ setOnMahasulReport }: any) => {
    const { SET_FULL_SOFT_DATA } = useSelector((state: RootState) => state.software);
    const { closeSidebar } = useSidebar('mahasul_rtp');
    const { data, loading, error, refetch } = useFetchData(AppURL.AccountURL + "account/customer/mahasul/options/list/view/");
    const dispatch = useDispatch();
    const readerOptions = ReaderOptions(data?.reader || []);

    const margaToleOptions = ToleOptions(data?.marga || []);
    const topSizeOptions = TapSizeOptions(data?.tap_size || []);
    const today = SET_FULL_SOFT_DATA?.today_np;
    const [year, month, day] = today.split('/');

    const month_starting = `${year}/${month}/01`;
    const initialValues = {
        date_from: month_starting || "",
        date_to: SET_FULL_SOFT_DATA?.today_np || "",
        marga: "",
        reader: "",
        gender: "",
        ward_no: "",
        customer_type: "",
        tap_size: "",
        tap_type: "",
        meter_type: ""
    };

    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const queryParams = new URLSearchParams();
            if (values.date_from) queryParams.append('date_from', values.date_from);
            if (values.date_to) queryParams.append('date_to', values.date_to);
            if (values.marga) queryParams.append('marga', values.marga);
            if (values.tap_size) queryParams.append('tap_size_id', values.tap_size.toString());
            queryParams.append('reader', values.reader);
            queryParams.append('gender', values.gender);
            if (values.ward_no) queryParams.append('ward_no', values.ward_no);
            if (values.customer_type) queryParams.append('customer_type', values.customer_type);
            if (values.tap_size) queryParams.append('tap_size', values.tap_size);
            if (values.tap_type) queryParams.append('tap_type', values.tap_type);
            try {
                const url = `${AppURL.AccountURL}account/customer/mahasul/collection/report/view/?${queryParams.toString()}`;
                await fetchDataFromApi(url).then((res) => {
                    if (res?.status === 200) {
                        setOnMahasulReport(res);
                        closeSidebar();
                        dispatch(ACCOUNT_RPT_DATE({
                            date: "",
                            date_from: values.date_from || "",  // Provide empty string if undefined
                            date_to: values.date_to || ""       // Provide empty string if undefined
                        }));
                    } else if (res?.status === 400) {
                    } else {
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });


    return (
        <Fragment>
            <form onSubmit={handleSubmit}>
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <Grid container columnSpacing={1} rowSpacing={0.8}>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <InputTextBox
                                    type='text'
                                    prefix={<CiCalendarDate />}
                                    handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'date_from' })}
                                    label='Date From(B.S.)'
                                    name='date_from'
                                    handleBlur={handleBlur}
                                    value={values.date_from}
                                    error={typeof errors.date_from === 'string' ? errors.date_from : undefined}
                                    touched={!!touched.date_from}
                                    placeholder='XXXX/XX/XX'
                                    required={true}
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <InputTextBox
                                    type='text'
                                    prefix={<CiCalendarDate />}
                                    handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'date_to' })}
                                    label='Date To(B.S.)'
                                    name='date_to'
                                    handleBlur={handleBlur}
                                    value={values.date_to}
                                    error={typeof errors.date_to === 'string' ? errors.date_to : undefined}
                                    touched={!!touched.date_to}
                                    placeholder='XXXX/XX/XX'
                                    required={true}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectionBox
                            name='marga'
                            label='Marga Tole'
                            handleChange={(fieldName, data: any) => (setFieldValue(fieldName, data ? data?.value : ""))}
                            value={values.marga || ""}
                            errors={errors.marga}
                            isLoading={loading}
                            options={margaToleOptions}
                            handleBlur={handleBlur}
                            touched={touched.marga}
                            required={false}
                            disabled={false}
                            clear
                            placeholder='Select Marga/Tole'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectionBox
                            name='reader'
                            label='Reader'
                            handleChange={(fieldName, data: any) => (setFieldValue(fieldName, data ? data?.value : ""))}
                            value={values.reader || ""}
                            errors={errors.reader}
                            options={readerOptions}
                            handleBlur={handleBlur}
                            isLoading={loading}
                            touched={touched.reader}
                            required={false}
                            disabled={false}
                            clear
                            placeholder='Select Reader Name'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <Grid container columnSpacing={1} rowSpacing={0.8}>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <SelectionBox
                                    name='gender'
                                    label='Gender'
                                    handleChange={(fieldName, data: any) => (setFieldValue(fieldName, data ? data?.value : ""))}
                                    value={values.gender || ""}
                                    errors={errors.gender}
                                    options={GenderOptions}
                                    handleBlur={handleBlur}
                                    touched={touched.gender}
                                    required={false}
                                    disabled={false}
                                    clear
                                    placeholder='Select Gender'
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                                <InputTextBox
                                    type='number'
                                    prefix={<CiCalendarDate />}
                                    handleChange={handleChange}
                                    label='Ward No.'
                                    name='ward_no'
                                    handleBlur={handleBlur}
                                    value={values.ward_no}
                                    error={typeof errors.ward_no === 'string' ? errors.ward_no : undefined}
                                    touched={!!touched.ward_no}
                                    placeholder='XX'
                                    required={false}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectionBox
                            name='customer_type'
                            label='Customer Type'
                            handleChange={(fieldName, data: any) => (setFieldValue(fieldName, data ? data?.value : ""))}
                            value={values.customer_type || ""}
                            errors={errors.customer_type}
                            options={MemberTypeOptions}
                            handleBlur={handleBlur}
                            touched={touched.customer_type}
                            required={false}
                            disabled={false}
                            clear
                            placeholder='Select Customer Type'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectionBox
                            name='meter_type'
                            label='Meter Type'
                            handleChange={(fieldName, data: any) => (setFieldValue(fieldName, data ? data?.value : ""))}
                            value={values.meter_type || ""}
                            errors={errors.meter_type}
                            options={MeterTypeOptions}
                            handleBlur={handleBlur}
                            touched={touched.meter_type}
                            required={false}
                            disabled={false}
                            clear
                            placeholder='Select Meter Type'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectionBox
                            name='tap_size'
                            label='Tap Size'
                            handleChange={(fieldName, data: any) => (setFieldValue(fieldName, data ? data?.value : ""))}
                            value={values.tap_size || ""}
                            errors={errors.tap_size}
                            options={topSizeOptions}
                            handleBlur={handleBlur}
                            isLoading={loading}
                            touched={touched.tap_size}
                            required={false}
                            clear
                            disabled={false}
                            placeholder='Select Tap Size'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectionBox
                            name='tap_type'
                            label='Tap Type'
                            handleChange={(fieldName, data: any) => (setFieldValue(fieldName, data ? data?.value : ""))}
                            value={values.tap_type || ""}
                            errors={errors.tap_type}
                            options={TapTypeOptions}
                            handleBlur={handleBlur}
                            touched={touched.tap_type}
                            required={false}
                            clear
                            disabled={false}
                            placeholder='Select Tap Type'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='search' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>
        </Fragment>
    )
}

export default MahasulRptFormView
